/* angular:styles/component:css;15d63d35027181770ecb1fbff57f298c8658752cf883b6692df8c6da778a5b02;/app/src/app/shared/animations/smooth-height.component.ts */
:host {
  display: block;
  overflow: hidden;
}
/*# sourceMappingURL=smooth-height.component.css.map */
